// extracted by mini-css-extract-plugin
export default {"form-group__input":"Wrapper_form-group__input__PnQCP","form-group__title":"Wrapper_form-group__title__en-Og"};